import { Grid, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const styles = {
  data: {
    paddingRight: '1.5rem',
  },
  label: {
    display: 'block',
    marginRight: '0.75rem',
    minWidth: '8rem',
    fontWeight: 500,
  },
};

function LabeledData({ label, data, stacked = false }) {
  if (stacked) {
    return (
      <div>
        <Typography variant="body2" id={label}>
          {label}
        </Typography>
        <Typography variant="caption" id={`${label}Data`}>
          {data}
        </Typography>
      </div>
    );
  }

  return (
    <Grid container spacing={1} style={styles.data}>
      <Grid item>
        <Typography variant="body2" style={styles.label} id={label}>
          {label}
        </Typography>
      </Grid>
      <Grid item>
        <Typography variant="caption" id={`${label}Data`}>
          {data}
        </Typography>
      </Grid>
    </Grid>
  );
}

LabeledData.propTypes = {
  label: PropTypes.string.isRequired,
  data: PropTypes.string.isRequired,
  stacked: PropTypes.bool,
};

LabeledData.defaultProps = {
  stacked: false,
};

export default LabeledData;
